import { Bell, CheckCircle, Clock, MessageSquare, UserPlus, AlertCircle, ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function NotificationsPage() {
  const [notifications, setNotifications] = useState([
  /*   {
      id: 1,
      type: 'message',
      title: 'New message received',
      description: 'You have a new message from Adanna Okoro',
      time: '5 minutes ago',
      isRead: false
    } */
  ]);

  // Function to mark all notifications as read
  const markAllAsRead = () => {
    setNotifications(notifications.map(notif => ({ ...notif, isRead: true })));
  };

  // Function to mark a specific notification as read
  const markAsRead = (id) => {
    setNotifications(notifications.map(notif => 
      notif.id === id ? { ...notif, isRead: true } : notif
    ));
  };

  // Function to get the appropriate icon based on notification type
  const getNotificationIcon = (type) => {
    switch (type) {
      case 'message':
        return <MessageSquare size={20} color="#fff" />;
      case 'reminder':
        return <Clock size={20} color="#fff" />;
      case 'connection':
        return <UserPlus size={20} color="#fff" />;
      case 'alert':
        return <AlertCircle size={20} color="#fff" />;
      case 'success':
        return <CheckCircle size={20} color="#fff" />;
      default:
        return <Bell size={20} color="#fff" />;
    }
  };

  // Function to get the appropriate color class based on notification type
  const getIconColorClass = (type) => {
    switch (type) {
      case 'message':
        return 'message-icon-notif';
      case 'reminder':
        return 'reminder-icon-notif';
      case 'connection':
        return 'connection-icon-notif';
      case 'alert':
        return 'alert-icon-notif';
      case 'success':
        return 'success-icon-notif';
      default:
        return '';
    }
  };

  return (
    <div className="notifications-container-notif">
      <div className="notifications-header-notif">
        <div className="notifications-title-wrapper-notif">
          <Link to="/farmer-dashboard/settings" className="back-button-notif">
            <ChevronLeft size={20} />
          </Link>
          <h1 className="settings-title-apss">Notifications</h1>
        </div>
        <button className="mark-read-button-notif" onClick={markAllAsRead}>
          Mark all as read
        </button>
      </div>
      
      <div className="notifications-list-notif">
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <div 
              key={notification.id} 
              className={`notification-card-notif ${!notification.isRead ? 'unread-notif' : ''}`}
              onClick={() => markAsRead(notification.id)}
            >
              <div className="notification-content-notif">
                <div className={`notification-icon-container-notif ${getIconColorClass(notification.type)}`}>
                  {getNotificationIcon(notification.type)}
                </div>
                <div className="notification-info-notif">
                  <h3 className="notification-title-notif">{notification.title}</h3>
                  <p className="notification-description-notif">{notification.description}</p>
                  <span className="notification-time-notif">{notification.time}</span>
                </div>
              </div>
              {!notification.isRead && <div className="unread-indicator-notif"></div>}
            </div>
          ))
        ) : (
          <div className="no-notifications-notif">
            <Bell size={48} className="no-notifications-icon-notif" />
            <p>You have no notifications</p>
          </div>
        )}
      </div>
    </div>
  );
}